import { useContext } from 'react'

import ServerSideContext from '../contexts/ServerSideContext'

const useIsServer = () => {
  const isServerSide = useContext(ServerSideContext)
  return isServerSide
}

export default useIsServer
